module.exports = __webpack_public_path__ + "img/floatright2.f5a0fa97.jpg";